<template>
  <v-app-bar app style="left:0;z-index:7" elevation="2">
    <v-toolbar-title>
      <img src="@/assets/taster_iam_header.png" alt="Taster IAM" class="mr-4 mt-1" height="40px" />
    </v-toolbar-title>
    <v-toolbar-title class="ml-4 hidden-sm-and-down">{{$route.name}}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-col cols="4" sm="4" class="hidden-sm-and-down">
      <v-autocomplete
        v-model="selected"
        :items="computedNavigation"
        :filter="searchFilter"
        item-text="name"
        :get-label="(item) => item.name"
        :counter="5"
        item-value="route"
        flat
        dense
        hide-details
        label="Search"
        solo-inverted
        prepend-icon="search"
      >
        <template v-slot:item="data">
          <v-list-item-icon>
            <v-icon>{{data.item.icon}}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-html="data.item.name"></v-list-item-title>
          </v-list-item-content>
        </template>
      </v-autocomplete>
    </v-col>
    <OrganizationSelector />
  </v-app-bar>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Roles from "@/router/roles";
import OrganizationSelector from "@/components/OrganizationSelector";

export default {
  components: { OrganizationSelector },
  data() {
    return {
      loading: false,
      selected: null,
      navigation: [],
      delay: 500
    };
  },
  computed: {
    ...mapState({
      all: state => state.navigation.all,
      superAdmin: state => state.navigation.superAdmin,
      admin: state => state.navigation.admin,
      access: state => state.navigation.access,
      dark: state => state.navigation.dark
    }),
    computedNavigation() {
      var nav = [];
      for (let page in this.navigation) {
        var p = this.navigation[page];
        if (!p.children) {
          nav.push({ name: p.name, route: p.route, icon: p.icon });
        }
        for (let child in p.children) {
          var child_p = p.children[child];
          nav.push({
            name: child_p.name,
            route: child_p.route,
            icon: child_p.icon
          });
        }
      }
      return nav;
    }
  },
  watch: {
    selected() {
      if (this.selected !== this.$route.path) this.$router.push(this.selected);
    }
  },
  methods: {
    ...mapActions("navigation", { changeTheme: "changeTheme" }),
    searchFilter(item, queryText) {
      const textOne = item.name.toLowerCase();
      const searchText = queryText.toLowerCase();
      return textOne.indexOf(searchText) > -1;
    },
    getNavigation() {
      var nav = [...this.all];
      if (this.$auth.getUserRoles().includes(Roles.SuperAdmin)) {
        nav = nav.concat([...this.superAdmin]);
      }
      if (this.$auth.getUserRoles().includes(Roles.Admin)) {
        nav = nav.concat([...this.admin]);
      }
      if (this.$auth.getUserRoles().includes(Roles.Editor)) {
        nav = nav.concat([...this.access]);
      }
      return nav;
    }
  },
  mounted() {
    setInterval(() => {
      if (this.$auth.keycloak.tokenParsed) {
        this.delay = 60000;
        this.navigation = this.getNavigation();
      }
    }, this.delay);
  }
};
</script>
